export default "__VITE_ASSET__c74a097d__"